import { useCallback, forwardRef } from 'react';
import { IMaskInput } from 'react-imask';

interface MaskInputProps {
  name: string;
  onChange: (event: { target: { name: string; value: string } }) => void;
  placeholder: string;
  mask: string;
  definitions: any;
}

const MaskInput = forwardRef<HTMLInputElement, MaskInputProps>((props, ref) => {
  const { onChange, placeholder, mask, definitions, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask={mask}
      definitions={definitions}
      placeholder={placeholder}
      inputRef={ref}
      onAccept={useCallback(
        value => {
          onChange({ target: { name: props.name, value } });
        },
        [props.name, onChange],
      )}
      overwrite
    />
  );
});

export { MaskInput };
export type { MaskInputProps };
